import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['documentSettingsModalVisible'] = false,
  action: Action,
): RootState['documentSettingsModalVisible'] {
  switch (action.type) {
    case 'DOCUMENT_SETTINGS_MODAL_VISIBLE_SET':
      return action.payload
    default:
      return state
  }
}
